import { Select, SelectTrigger, SelectValue } from "../../ui/select";
import { useAsOf, type AsOfPage } from "../../pages/PortfolioPerformance/lib/api/as-of";

/** "2026-09-30" -> "30 Sep 2026" (parsed as a calendar date, so no timezone can move it a day). */
function formatAsOf(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

/**
 * The date a page's cards are as of, in the look of the page's own dropdowns (the filter bar's) but disabled: a label above a small
 * select-shaped box that reads the date and cannot be opened. Sits at the top right of the page header, above the divider.
 */
export function AsOfCard({ page }: { page: AsOfPage }) {
  const { data, isError } = useAsOf(page);
  const text = data?.asOf ? formatAsOf(data.asOf) : isError || data ? "—" : "…";
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">As of</span>
      <Select value="as-of" disabled>
        {/* [&>svg]:hidden: the select's own arrow is dropped here, since this one cannot be opened. */}
        <SelectTrigger className="h-9 w-40 border-border bg-secondary text-sm [&>svg]:hidden" aria-label="As of date">
          <SelectValue>{text}</SelectValue>
        </SelectTrigger>
      </Select>
    </label>
  );
}
